var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('span', {
    class: ['currency-wrapper', _vm.$props.classes]
  }, [_vm._v(" " + _vm._s(_vm.currencyText) + " "), _vm._t("default")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }